module.exports = __webpack_public_path__ + "img/store.1ace8bf4.png";